var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { auth } from '../config/firebase';
var BACKEND_URL = process.env.REACT_APP_API_URL;
if (!BACKEND_URL) {
    throw new Error('REACT_APP_API_URL environment variable is not set');
}
var api = axios.create({
    baseURL: BACKEND_URL,
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    validateStatus: function (status) { return status < 500; }
});
var statusApi = axios.create({
    baseURL: BACKEND_URL,
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    timeout: 10000,
    validateStatus: function (status) { return status < 500; }
});
api.interceptors.request.use(function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var user, token, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                user = auth.currentUser;
                if (!user) {
                    throw new Error('Authentication required');
                }
                return [4 /*yield*/, user.getIdToken()];
            case 1:
                token = _a.sent();
                config.headers.Authorization = "Bearer ".concat(token);
                return [2 /*return*/, config];
            case 2:
                error_1 = _a.sent();
                return [2 /*return*/, Promise.reject(new Error('Authentication failed. Please try logging out and back in.'))];
            case 3: return [2 /*return*/];
        }
    });
}); });
api.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, Promise.reject(error)];
    });
}); });
statusApi.interceptors.request.use(function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var user, token, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                user = auth.currentUser;
                if (!user) {
                    throw new Error('Authentication required');
                }
                return [4 /*yield*/, user.getIdToken()];
            case 1:
                token = _a.sent();
                config.headers.Authorization = "Bearer ".concat(token);
                return [2 /*return*/, config];
            case 2:
                error_2 = _a.sent();
                return [2 /*return*/, Promise.reject(new Error('Authentication failed. Please try logging out and back in.'))];
            case 3: return [2 /*return*/];
        }
    });
}); });
statusApi.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, Promise.reject(error)];
    });
}); });
export var nasdaq100XGBoostApi = {
    predict: function (request) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_3;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api.post('/api/nasdaq100/predict', request)];
                case 1:
                    response = _c.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    error_3 = _c.sent();
                    if (axios.isAxiosError(error_3)) {
                        throw new Error(((_b = (_a = error_3.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.detail) || 'Failed to start prediction. Please try again.');
                    }
                    throw error_3;
                case 3: return [2 /*return*/];
            }
        });
    }); },
    getPredictionStatus: function (requestId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_4;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, statusApi.get("/api/nasdaq100/predict/status/".concat(requestId))];
                case 1:
                    response = _c.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    error_4 = _c.sent();
                    if (axios.isAxiosError(error_4)) {
                        if (error_4.code === 'ECONNABORTED') {
                            return [2 /*return*/, { status: 'running', message: 'Prediction is still running...' }];
                        }
                        throw new Error(((_b = (_a = error_4.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.detail) || 'Failed to get prediction status');
                    }
                    throw error_4;
                case 3: return [2 /*return*/];
            }
        });
    }); }
};
export default api;
